import { BlockchainID, Web3Address } from 'multirpc-sdk';

import { AppDispatch, RootState } from 'store';
import { IProjectWithBlockchains } from 'domains/projects/types';
import { selectJWTs } from 'domains/jwtToken/action/fetchJWTs';
import { web3Api } from 'store/queries';

import { fetchProjectsWhitelistsBlockchains } from '../fetchProjectsWhitelistsBlockchains';

export interface UpdateProjectsWhitelistsBlockchainsParams {
  blockchains: BlockchainID[];
  dispatch: AppDispatch;
  getState: () => unknown;
  teamAddress?: Web3Address;
  userEndpointToken: string;
}

export const updateProjectsWhitelistsBlockchains = ({
  blockchains,
  dispatch,
  getState,
  teamAddress,
  userEndpointToken,
}: UpdateProjectsWhitelistsBlockchainsParams) => {
  const state = getState() as RootState;

  const projects = selectJWTs(state, { group: teamAddress });

  dispatch(
    web3Api.util.updateQueryData(
      fetchProjectsWhitelistsBlockchains.name as never,
      { group: teamAddress, projects } as never,
      (draft: IProjectWithBlockchains[] = []) => {
        const foundProject = draft.find(
          project => project.userEndpointToken === userEndpointToken,
        );

        if (foundProject) {
          foundProject.blockchains = blockchains;
        }
      },
    ),
  );
};
